import Manualdisbursementview from "../../../jsx/components/Dashboard/LoanDetails/manualdisbursementview";

const ManualDisbursementViewWrapper = () => {
  return <Manualdisbursementview />;
};

export default constore(ManualDisbursementViewWrapper);
